import { render, staticRenderFns } from "./EnviarAbonos.vue?vue&type=template&id=25ca840f"
import script from "./EnviarAbonos.vue?vue&type=script&lang=js"
export * from "./EnviarAbonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports